// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"RankingHeader_headerWrapper__2OjNW","rankingHeader":"RankingHeader_rankingHeader__J3UcA","headerTitle":"RankingHeader_headerTitle__1NK7y"};